export class ShellBffHttpError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly method: string,
    public readonly url: string,
    public readonly responseBody?: unknown,
  ) {
    super(message)
    this.name = 'ShellBffHttpError'
  }
}

export class ShellBffNetworkError extends Error {
  constructor(
    message: string,
    public readonly cause?: unknown,
  ) {
    super(message)
    this.name = 'ShellBffNetworkError'
  }
}
